import React, { useState, useEffect, useCallback } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import Dashboard from './components/Dashboard'
import Learning from './components/Learning'
import LearningExercise from './components/LearningExercise'
import Login from './components/Login';
import './components/Login.css';
import './App.css'
import Statistik from './components/Statistik';
import './components/Statistik.css';
import LearningTopics from './components/LearningTopics';
import Account from './components/Account';
import { secureStorage } from './utils/secureStorage';



// Importiere die existierenden Komponenten (falls vorhanden)
// Falls LoginScreen nicht existiert, verwenden wir eine temporäre Lösung

// Entferne StyledLogin und verwende stattdessen <Login setToken={handleSetToken} />

function App() {
  const [token, setToken] = useState(secureStorage.getToken())

  useEffect(() => {
    const storedToken = secureStorage.getToken()
    if (storedToken) {
      // Prüfe Token-Gültigkeit beim App-Start
      if (secureStorage.isTokenValid(storedToken)) {
        setToken(storedToken)
      } else {
        // Token ist abgelaufen - automatisch ausloggen
        console.log('🔐 Token beim App-Start abgelaufen - automatisches Logout');
        secureStorage.clearToken();
        setToken(null);
      }
    }
  }, [])

  const handleSetToken = (newToken) => {
    if (newToken) {
      secureStorage.setToken(newToken)
    } else {
      secureStorage.clearToken();
    }
    setToken(newToken)
  }

  // Komponente für geschützte Routen mit Token-Validierung
  const ProtectedRoute = useCallback(({ children }) => {
    // Verwende den bereits im State gespeicherten Token
    if (!token || !secureStorage.isTokenValid(token)) {
      console.log('🔐 Token ungültig oder abgelaufen - Weiterleitung zum Login');
      // Token ist abgelaufen oder ungültig - automatisch ausloggen
      secureStorage.clearToken();
      setToken(null);
      return <Navigate to="/login" replace />;
    }
    
    return children;
  }, [token]);

  return (
    <div className="App">
      <Routes>
        <Route 
          path="/login" 
          element={!token ? <Login setToken={handleSetToken} /> : <Navigate to="/dashboard" />} 
        />
        <Route 
          path="/dashboard" 
          element={
            <ProtectedRoute>
              <Dashboard setToken={handleSetToken} />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/learning" 
          element={
            <ProtectedRoute>
              <Learning setToken={handleSetToken} />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/learning/:moduleSlug/topics" 
          element={
            <ProtectedRoute>
              <LearningTopics />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/learning/:moduleSlug/:topicSlug" 
          element={
            <ProtectedRoute>
              <LearningExercise setToken={handleSetToken} />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/learning/:moduleSlug" 
          element={
            <ProtectedRoute>
              <LearningExercise setToken={handleSetToken} />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/statistik" 
          element={
            <ProtectedRoute>
              <Statistik setToken={handleSetToken} />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/account" 
          element={
            <ProtectedRoute>
              <Account setToken={handleSetToken} />
            </ProtectedRoute>
          } 
        />
        <Route path="/" element={<Navigate to="/dashboard" />} />
      </Routes>
    </div>
  )
}

export default App